import { render, staticRenderFns } from "./CandidateNoteCreateModal.vue?vue&type=template&id=1c36c17e&"
import script from "./CandidateNoteCreateModal.vue?vue&type=script&lang=js&"
export * from "./CandidateNoteCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports